import React, { useEffect, useRef } from 'react';
import { gsap } from '../../hooks/useGsap';

/**
 * Infinite horizontal marquee using GSAP.
 * Children should be a single set of items — the component duplicates them.
 */
const Marquee = ({ children, speed = 40, className = '', reverse = false }) => {
  const trackRef = useRef(null);

  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;

    // We render the children twice; animating between 0 and -50% loops
    // seamlessly (reverse starts at -50% and slides back to 0).
    const ctx = gsap.context(() => {
      gsap.fromTo(
        track,
        { xPercent: reverse ? -50 : 0 },
        {
          xPercent: reverse ? 0 : -50,
          duration: speed,
          ease: 'none',
          repeat: -1,
        }
      );
    }, track);

    return () => ctx.revert();
  }, [speed, reverse]);

  return (
    <div className={`overflow-hidden mask-fade-x ${className}`}>
      <div ref={trackRef} className="marquee-track gap-12">
        <div className="flex items-center gap-12 shrink-0">{children}</div>
        <div className="flex items-center gap-12 shrink-0" aria-hidden="true">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Marquee;
